import { useQuery, UseQueryOptions } from 'react-query';

import API from 'api';
import { QUERY_KEYS } from 'api/certificates/queries';
import { DocumentModel } from 'api/documents/documents.model';
import { CertificateDetailsModel } from 'models/certificate.model';

export const useCertificateQuery = (
  id: string,
  options?: UseQueryOptions<DocumentModel<CertificateDetailsModel>>
) =>
  useQuery<DocumentModel<CertificateDetailsModel>>(
    [QUERY_KEYS.GET_CERTIFICATE, id],
    async () => API.documents.getDocumentsID(id),
    { ...options, refetchOnWindowFocus: false }
  );
